export const _planningFr = {
    onDuty: 'Garde',
    onCall: 'Astreinte',
    available: 'Disponible',
    unspecified: 'Non renseigné',
    planningStatus: 'État de planning',
    startPlanningTime: 'Heure de début de planning',
    endPlanningTime: 'Heure de fin de planning',
    noEntry: 'Aucune entrée',
    deletePlanning: 'Supprimer le planning',
};

export const _planningEn = {
    onDuty: 'On duty',
    onCall: 'On call',
    available: 'Available',
    unspecified: 'Unspecified',
    planningStatus: 'Planning status',
    startPlanningTime: 'Start planning time',
    endPlanningTime: 'End planning time',
    noEntry: 'No entry',
    deletePlanning: 'Delete planning',
};

export const _planningDe = {
    onDuty: 'Dienst',
    onCall: 'Bereitschaft',
    available: 'Verfügbar',
    unspecified: 'Nicht spezifiziert',
    planningStatus: 'Planungsstatus',
    startPlanningTime: 'Startzeit der Planung',
    endPlanningTime: 'Endzeit der Planung',
    noEntry: 'Kein Eintrag',
    deletePlanning: 'Planung löschen',
};
